"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Convert = void 0;
var tslib_1 = require("tslib");
/**
 * Created by wangtong on 2020/12/30
 */
var internal_1 = require("./internal");
var json_bigint_1 = tslib_1.__importDefault(require("json-bigint"));
var yaml_1 = tslib_1.__importDefault(require("yaml"));
var TOML = require('@iarna/toml');
var MimeReg = new RegExp(':(.*?);');
function extractFromBase64(base64) {
    var arr = base64.split(',');
    var mime_match = arr[0].match(MimeReg);
    var mime = '';
    if (mime_match) {
        mime = mime_match[1];
    }
    var byte = atob(arr[1]);
    return {
        mime: mime, byte: byte
    };
}
var Convert;
(function (Convert) {
    function parseString(value, def) {
        if (def === void 0) { def = ""; }
        value = parseStringOrNull(value);
        return value === null ? def : value;
    }
    Convert.parseString = parseString;
    function parseStringOrNull(value, def_value) {
        // def: 当value为空的时候返回def
        var value_when_empty = def_value === undefined ? null : def_value;
        switch (typeof value) {
            case "number":
                return value.toString();
            case "string":
                return value || value_when_empty;
            case "bigint":
                return value.toString();
            case "boolean":
                return value ? 'true' : 'false';
            case "undefined":
                return value_when_empty;
            case "object":
                return value === null ? value_when_empty : JSON.stringify(value);
            default:
                return JSON.stringify(value);
        }
    }
    Convert.parseStringOrNull = parseStringOrNull;
    function parseBool(value) {
        switch (typeof value) {
            case "string":
                return value === "true" || value === "ok" || value === "yes" || value === "1";
            case "undefined":
                return false;
            case "bigint":
                return value === BigInt(1);
            case "number":
                return value === 1;
            case "boolean":
                return value;
            default:
                return internal_1.isEmpty(value);
        }
    }
    Convert.parseBool = parseBool;
    function parseInt(value, def_value) {
        if (def_value === void 0) { def_value = 0; }
        value = parseIntOrNull(value);
        return value === null ? def_value : value;
    }
    Convert.parseInt = parseInt;
    function parseIntOrNull(value, def_value) {
        var value_when_empty = def_value === undefined ? null : def_value;
        switch (typeof value) {
            case "boolean":
                return value ? 1 : 0;
            case "number":
                return Math.round(value);
            case "bigint":
                return Number(value);
            case "string":
                value = Number.parseInt(value);
                return isNaN(value) ? value_when_empty : value;
            default:
                return value_when_empty;
        }
    }
    Convert.parseIntOrNull = parseIntOrNull;
    function parseFloat(value, def_value) {
        if (def_value === void 0) { def_value = 0; }
        value = parseFloatOrNull(value);
        return value === null ? def_value : value;
    }
    Convert.parseFloat = parseFloat;
    function parseFloatOrNull(value, def_value) {
        var value_when_empty = def_value === undefined ? null : def_value;
        switch (typeof value) {
            case "boolean":
                return value ? 1 : 0;
            case "number":
                return value;
            case "bigint":
                return Number(value);
            case "string":
                value = Number.parseFloat(value);
                return isNaN(value) ? value_when_empty : value;
            default:
                return value_when_empty;
        }
    }
    Convert.parseFloatOrNull = parseFloatOrNull;
    /**
     * 解析JSON字符串
     * @param value
     * @returns {{}}
     */
    function parseJson(value) {
        var res;
        try {
            res = tslib_1.__assign({}, json_bigint_1.default({ storeAsString: true }).parse(value));
        }
        catch (e) {
            res = {};
        }
        return res;
    }
    Convert.parseJson = parseJson;
    function parseItem(value) {
        if (typeof value === "object") {
            if (Array.isArray(value)) {
                return value.map(function (item) { return parseItem(item); });
            }
            else {
                return tslib_1.__assign({}, value);
            }
        }
        else {
            return value;
        }
    }
    function parseArray(value) {
        var res;
        try {
            res = parseItem(json_bigint_1.default({ storeAsString: true }).parse(value));
            if (Array.isArray(res)) {
                return res;
            }
            else {
                return [];
            }
        }
        catch (e) {
            res = [];
        }
        return res;
    }
    Convert.parseArray = parseArray;
    /**
     * 解析Toml字符串
     * @param value
     * @returns {{}}
     */
    function parseToml(value) {
        var res;
        try {
            res = TOML.parse(value);
        }
        catch (e) {
            res = {};
        }
        return res;
    }
    Convert.parseToml = parseToml;
    /**
     * 解析Yaml字符串
     * @param value
     */
    function parseYaml(value) {
        var res;
        try {
            res = yaml_1.default.parse(value);
        }
        catch (e) {
            res = {};
        }
        return res;
    }
    Convert.parseYaml = parseYaml;
    // 将图片转换为base64
    function imageURLToBase64(image_url) {
        return new Promise(function (resolve) {
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext('2d');
            var img = new Image();
            img.setAttribute('crossOrigin', '');
            img.onload = function () {
                canvas.height = img.height;
                canvas.width = img.width;
                if (ctx) {
                    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                    var dataURL = canvas.toDataURL('image/png');
                    resolve(dataURL);
                }
                else {
                    resolve(null);
                }
            };
            img.src = image_url;
        });
    }
    Convert.imageURLToBase64 = imageURLToBase64;
    function base64ToFile(base64, filename) {
        var _a = extractFromBase64(base64), mime = _a.mime, byte = _a.byte;
        var n = byte.length;
        var u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = byte.charCodeAt(n);
        }
        // let blob = new Blob([u8arr], {of: mime});
        // blob.lastModifiedTime = Date.now();
        // blob.name = filename;
        return new File([u8arr], filename, { type: mime });
        // return blob;
    }
    Convert.base64ToFile = base64ToFile;
    function blobToBase64(blob) {
        return new Promise(function (resolve) {
            var fileReader = new FileReader();
            fileReader.onload = function (event) {
                if (event.target) {
                    resolve(event.target.result);
                }
                else {
                    resolve(null);
                }
            };
            fileReader.readAsDataURL(blob);
        });
    }
    Convert.blobToBase64 = blobToBase64;
    function base64ToBlob(base64) {
        var _a = extractFromBase64(base64), mime = _a.mime, byte = _a.byte;
        var n = byte.length;
        var u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = byte.charCodeAt(n);
        }
        return new Blob([u8arr], { type: mime });
    }
    Convert.base64ToBlob = base64ToBlob;
    function jsonlToCsv(jsonl) {
        if (jsonl.length === 0) {
            return "";
        }
        return [
            Object.keys(jsonl[0]).map(function (key) { return JSON.stringify(key); }).join(","),
            jsonl.map(function (item) {
                return Object.values(item).map(function (value) { return JSON.stringify(value); }).join(",");
            }).join("\n")
        ].join("\n");
    }
    Convert.jsonlToCsv = jsonlToCsv;
    function stringifyYaml(json, options) {
        return yaml_1.default.stringify(json, options);
    }
    Convert.stringifyYaml = stringifyYaml;
    function stringifyToml(json) {
        return TOML.stringify(json);
    }
    Convert.stringifyToml = stringifyToml;
    function parseIds(value) {
        return value.split(',').map(function (x) { return parseInt(x); });
    }
    Convert.parseIds = parseIds;
    // 如果是列表，直接返回，如果不是列表，则将其包装一层列表返回
    function toList(val) {
        if (Array.isArray(val)) {
            return val;
        }
        else {
            return [val];
        }
    }
    Convert.toList = toList;
})(Convert || (Convert = {}));
exports.Convert = Convert;
//# sourceMappingURL=convert.js.map